import { ColregsGiveWay } from "./colregs-giveway.js";
import { FishingPattern } from "./fishing-pattern.js";
import { FollowLane } from "./follow-lane.js";
import { RaceFleet } from "./race-fleet.js";
import { RandomWalk } from "./random-walk.js";
import { registerBehaviour } from "./registry.js";

export * from "./types.js";
export * from "./registry.js";
export * from "./rng.js";
export { FollowLane } from "./follow-lane.js";
export { RandomWalk } from "./random-walk.js";
export { FishingPattern } from "./fishing-pattern.js";
export { ColregsGiveWay } from "./colregs-giveway.js";
export { RaceFleet } from "./race-fleet.js";

let registered = false;

/**
 * Register all built-in behaviours. Idempotent — safe to call from multiple
 * modules at app startup. The host calls this once before constructing a
 * `LocalSimSource`; tests that need a clean slate can call
 * `clearBehaviours()` then this function again.
 */
export function registerBuiltInBehaviours(): void {
  if (registered) return;
  registerBehaviour(FollowLane);
  registerBehaviour(RandomWalk);
  registerBehaviour(FishingPattern);
  registerBehaviour(ColregsGiveWay);
  registerBehaviour(RaceFleet);
  registered = true;
}

export function resetBuiltInBehaviourRegistration(): void {
  registered = false;
}
